import { MaskitoOptions, maskitoTransform } from '@maskito/core';

import { PhoneMaskProps } from './types';

// Самый длинный номер телефона, который может быть в мире https://nda.ya.ru/t/ARwoCdaS73h5fe
const MAX_PHONE_DIGITS_COUNT = 15;
const DIGIT_REGEXP = /\d/;

const BASE_RU_MASK = [
    ' ',
    '(',
    DIGIT_REGEXP,
    DIGIT_REGEXP,
    DIGIT_REGEXP,
    ')',
    ' ',
    DIGIT_REGEXP,
    DIGIT_REGEXP,
    DIGIT_REGEXP,
    '-',
    DIGIT_REGEXP,
    DIGIT_REGEXP,
    '-',
    DIGIT_REGEXP,
    DIGIT_REGEXP,
];

export const getPhoneMask = (phoneMaskProps: PhoneMaskProps = {}): MaskitoOptions => {
    const { allowAnyRegion = false, allowOptionalPlus = false } = phoneMaskProps;

    if (allowAnyRegion) {
        return {
            mask: elementState => {
                const digitsCount = elementState.value.replace(/[^\d\*]/, '').length;
                const limitedByMaxDigitsCount = Math.min(digitsCount, MAX_PHONE_DIGITS_COUNT);

                if (allowOptionalPlus && elementState.value.startsWith('8')) {
                    return new Array<RegExp>(limitedByMaxDigitsCount || 1).fill(DIGIT_REGEXP);
                }

                return ['+', ...new Array<RegExp>(limitedByMaxDigitsCount || 1).fill(DIGIT_REGEXP)];
            },
        };
    }

    return {
        mask: elementState => {
            if (allowOptionalPlus && elementState.value.startsWith('8')) {
                return ['8', ...BASE_RU_MASK];
            }

            return ['+', '7', ...BASE_RU_MASK];
        },
    };
};

export const transformPhoneToMasked = (phone: string, phoneMaskProps: PhoneMaskProps = {}) => {
    const mask = getPhoneMask(phoneMaskProps);

    return maskitoTransform(phone, mask);
};
